<template>
    <div>
        <v-row no-gutters class="item flex-nowrap">
            <!-- Image View (Reverse) -->
            <v-col>
                <div
                    :style="{
                        'height': `${height}px`,
                        'background-image': `url(${IMAGESURL[selectedImg]})`,
                        'background-position': `${zoomImg.x}% ${zoomImg.y}%`,
                        'background-size': `${
                            !zoomImg.active ? 'contain' : `${zoomImg.percent}%`
                        }`,
                    }"
                    style="
                        min-height: 210px;
                        border: 1px solid lightgrey;
                        transition: background-size 0.2s;
                    "
                    class="ma-1"
                    @mousemove="calPos"
                    @mouseleave="resetPos"
                    @mousewheel.prevent="changeZoom"
                ></div>

                <!-- <v-card class="mx-auto" style="" outlined>
                    <v-img
                        v-for="(src, i) in IMAGESURL"
                        :key="i"
                        :src="src"
                        :style="i != selectedImg ? `display: none;` : ``"
                        class="mx-auto"
                        height="320"
                        width="450"
                        contain
                    ></v-img>

                    <div v-for="(src, i) in IMAGESURL" :key="i">
                        <v-img
                            :src="src"
                            :style="i != selectedImg ? `display: none;` : ``"
                            height="320"
                            width="470"
                            contain
                        ></v-img>
                    </div>
                </v-card> -->
            </v-col>

            <!-- Image Selector -->
            <v-col class="shrink">
                <template v-for="(n, i) in IMAGESURL.length">
                    <v-card
                        :key="i"
                        v-if="n <= MAX_SELECTOR_VIEW"
                        tile
                        outlined
                        class="ma-1"
                        :style="{
                            'border-color': `${
                                selectedImg == i ? 'black' : ''
                            }`,
                        }"
                        style="padding: 1px"
                        :ripple="false"
                        @click="selectedImg = i"
                    >
                        <v-img
                            :aspect-ratio="1 / 1"
                            width="70"
                            :src="IMAGESURL[i]"
                        >
                            <div
                                v-if="
                                    n == MAX_SELECTOR_VIEW &&
                                    IMAGESURL.length > MAX_SELECTOR_VIEW
                                "
                                class="fill-height white--text d-flex justify-center align-center"
                                style="background: rgba(0, 0, 0, 0.5)"
                            >
                                + {{ IMAGESURL.length - MAX_SELECTOR_VIEW + 1 }}
                            </div>
                        </v-img>
                    </v-card>
                </template>

                <!-- Initial Idea -->
                <!-- <v-card
                    v-for="(src, i) in IMAGESURL"
                    :key="i"
                    tile
                    outlined
                    class="ma-2"
                    :style="{
                        'border-color': `${selectedImg == i ? 'black' : ''}`,
                    }"
                    style="padding: 1px"
                    :ripple="false"
                    @click="selectedImg = i"
                >
                    <v-img :aspect-ratio="1 / 1" width="70" :src="src"></v-img>
                </v-card> -->
            </v-col>
        </v-row>
    </div>
</template>

<script>
export default {
    props: ["imagesURL", "height", "maxPreview"],
    data() {
        return {
            selectedImg: 0,
            zoomImg: { x: 50, y: 50, active: false, percent: 250 },
            MAX_SELECTOR_VIEW: 4,
            IMAGESURL: [],
        };
    },
    mounted() {
        if (this.maxPreview) this.MAX_SELECTOR_VIEW = this.maxPreview;
        if (this.imagesURL) this.IMAGESURL = this.imagesURL;
    },
    methods: {
        calPos(e) {
            let { x, y, width, height } = e.target.getBoundingClientRect();
            let { clientX: mouse_abx, clientY: mouse_aby } = e;
            x = mouse_abx - x;
            y = mouse_aby - y;
            let px = ((x * 100) / width).toFixed(2),
                py = ((y * 100) / height).toFixed(2);
            this.zoomImg = { ...this.zoomImg, x: px, y: py, active: true };
        },
        resetPos(e) {
            this.zoomImg = { ...this.zoomImg, x: 50, y: 50, active: false };
        },
        changeZoom(e) {
            let percent = this.zoomImg.percent * (e.deltaY < 0 ? 1.08 : 0.92);
            if (percent > 140 && percent < 500) this.zoomImg.percent = percent;
        },
    },
    watch: {
        imagesURL() {
            if (this.imagesURL) this.IMAGESURL = this.imagesURL;
        },
        maxPreview() {
            if (this.maxPreview) this.MAX_SELECTOR_VIEW = this.maxPreview;
        }
    }
};
</script>

<style scoped lang="scss">
.item {  
    flex-direction: row-reverse;  
    @media #{map-get($display-breakpoints, 'xs-only'  )} {
        display: block;
        .col:last-child {
            display: flex;
            justify-content: center;
            overflow-x: auto;
        }
    }
}
</style>